export default "__VITE_ASSET__DiVytq2W__"